import React from 'react';
import '../App.css';
import refundImage from '../assets/refund.avif';
import Footer from '../components/Footer';

const RefundPolicy = () => {
  return (
    <div className="calisthenics-page">
      {/* Hero Section */}
      <div
        className="calisthenics-banner"
        style={{ backgroundImage: `url(${refundImage})` }}
      >
        <div className="banner-overlay"></div>
        <h2>REFUND POLICY</h2>
      </div>

      {/* Refund Policy Content */}
      <div className="container blog-margin mt-5">
        <div className="blog-content mt-5">
          {/* Effective Date - Now aligned with content */}
          <div className="date-section mb-4">
            <h3 className="date" style={{ fontSize: '1.2rem' }}>Effective Date: March 31, 2026</h3>
          </div>

          <p className="blog">
            <strong>Core Flow Fit</strong> (“we”, “our”, or “us”) is committed to providing a high-quality fitness experience. This Subscription & Refund Policy outlines the terms for our free and premium services.
          </p>

          <div>
            <h6 className="blog-h mt-3">1. Free App Access</h6>
            <p className="blog mt-2">
              Core Flow Fit can be downloaded and used for free. Users have access to a selection of free
              workouts, exercises, and features within the app. The free section allows users to explore the Core
              Flow Fit training approach before choosing to subscribe.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">2. Premium Subscription</h6>
            <p className="blog mt-2">
              The premium subscription unlocks the full Core Flow Fit experience including the complete workout
              library, advanced calisthenics programs, breathwork sessions, mobility routines, and additional
              training content. The premium subscription costs $29 per month and renews automatically unless cancelled.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">3. Automatic Renewal</h6>
            <p className="blog mt-2">
              Subscriptions automatically renew each month through the user’s app store account unless
              cancelled before the renewal date. Users can cancel their subscription at any time through their app
              store account settings. Access to premium content continues until the end of the current billing period.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">4. 48-Hour Cooling-Off Period</h6>
            <p className="blog mt-2">
              Core Flow Fit offers a 48-hour cooling-off period for new subscriptions. If a refund request is
              made within 48 hours of the initial subscription purchase, the request may be reviewed and
              considered. Refunds are not guaranteed and may depend on the level of premium content usage.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">5. App Store Purchases</h6>
            <p className="blog mt-2">
              Subscriptions purchased through mobile devices are processed through the Apple App Store or
              Google Play Store. Refund requests must therefore be submitted directly through the respective
              platform, as Core Flow Fit does not process payments or refunds directly.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">6. Billing Errors or Technical Issues</h6>
            <p className="blog mt-2">
              Refunds may be considered in cases of duplicate billing, incorrect charges, or technical issues that
              prevent access to premium content.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">7. Contact Support</h6>
            <p className="blog mt-2">
              For billing or subscription support, please contact: <br />
              <strong>Core Flow Fit</strong> <br />
              Email: <a 
                href="mailto:infocoreflowfit@gmail.com" 
                style={{ color: 'white', textDecoration: 'underline' }}
              >
                infocoreflowfit@gmail.com
              </a>
            </p>
          </div>

          <p className="bold mt-5 mb-5">
            We value your satisfaction and appreciate your understanding of our subscription policy. Thank you for choosing Core Flow Fit.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default RefundPolicy;